import i18n from '../../i18n';

export class Text {
  static get closeModal(): string {
    return i18n._translate('Close', { context: 'A button to close an error modal that will hide when clicked.' });
  }

  static get openModal(): string {
    return i18n._translate('More Details', {
      context: 'A button to open an error modal that will show information about the issue.',
    });
  }
}
